import { hashString } from '../libs/stringHashing';
import AbstractNotification from './YPAbstractNotificationObject';

export default class UpdateNotification extends AbstractNotification {
  constructor(id, timestampString, isRead, notificationMessage, tag) {
    super(id, timestampString, isRead, notificationMessage);
    this.tag = tag;
  }

  getTag() {
    return this.tag;
  }

  getPath() {
    return 'updateNotifications';
  }

  getNotifications(rosterNotifications, updateNotifications, timesheetNotifications) {
    return updateNotifications;
  }

  isUpdateNotification() {
    return true;
  }

  printTagForUpdateNotification() {
    switch (this.tag) {
      case 'release':
        return i18n('New!');
      case 'maintenance':
        return i18n('Maintenance');
      case 'text':
      default:
        return null;
    }
  }

  getNotificationIdWithMessageHash() {
    const hashedMessage = hashString(this.notificationMessage);
    return `${this.id}-${hashedMessage}`;
  }
}
